/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
document.addEventListener('DOMContentLoaded', () => {

    const blocks = document.querySelectorAll('.karting-pinto-track');

    blocks.forEach(block => {
        const radios = block.querySelectorAll('.js-track-type input[type="radio"]');
        const tips = block.querySelectorAll('.karting-pinto-track__tip');
        let currentTrackType = 'renting';

        radios.forEach((radio, index) => {
            radio.addEventListener('change', () => {

                const isCompetition = index === 1; // segundo radio
                currentTrackType = isCompetition ? 'competition' : 'renting';

                // 🔵🔴 Cambiar color de fondo
                block.classList.toggle('is-blue', isCompetition);
                block.classList.toggle('is-red', !isCompetition);

                const total = tips.length;

                tips.forEach((tip, i) => {
                    const numberSpan = tip.querySelector('.karting-pinto-track__tip-number');

                    if (isCompetition) {
                        if (i === 0) {
                            // Primer punto siempre 1
                            tip.id = `track-competition-point-1`;
                            numberSpan.textContent = 1;
                        } else {
                            // Invertir resto de los puntos
                            const compNumber = total - i + 1;
                            tip.id = `track-competition-point-${compNumber}`;
                            numberSpan.textContent = compNumber;
                        }
                    } else {
                        tip.id = `track-renting-point-${i + 1}`;
                        numberSpan.textContent = i + 1;
                    }
                });

            });
        });

        let currentIndexInSequence = -1;
        const rentingSequence = [0, 1, 2, 3, 4, 5, 6, 7]; // Orden por índices para Renting
        const competitionSequence = [0, 7, 6, 5, 4, 3, 2, 1]; // Orden por índices para Competición (Curva 1, 2, 3...)

        const updateModalContent = (sequenceIndex) => {
            const sequence = currentTrackType === 'competition' ? competitionSequence : rentingSequence;
            const tipIndex = sequence[sequenceIndex];
            const tip = tips[tipIndex];
            if (!tip) return;

            currentIndexInSequence = sequenceIndex;
            const numberSpan = tip.querySelector('.karting-pinto-track__tip-number');
            const pointNumber = numberSpan.textContent;
            const modal = document.querySelector('.js-kp-tip-modal');
            const modalImgContainer = modal.querySelector('.karting-pinto-modal__img');

            const currentTypeCapitalized = currentTrackType.charAt(0).toUpperCase() + currentTrackType.slice(1);

            // Determinar si es renting o competition
            const imageSrc = tip.dataset[`image${currentTypeCapitalized}`];
            const mediaType = tip.dataset[`type${currentTypeCapitalized}`] || 'image';

            // Cambiar la imagen o vídeo
            if (mediaType === 'video') {
                modalImgContainer.innerHTML = `<video src="${imageSrc}" autoplay muted loop controls playsinline style="width: 100%; height: 100%; object-fit: cover;"></video>`;
            } else {
                modalImgContainer.innerHTML = `<img src="${imageSrc}" alt="Track Point ${pointNumber}" />`;
            }

            // Cambiar contenido del modal
            const modalTitle = tip.dataset[`title${currentTypeCapitalized}`] || '';
            const modalText = tip.dataset[`text${currentTypeCapitalized}`] || '';
            // const modalButton = tip.dataset[`button${currentTypeCapitalized}`] || '';

            modal.querySelector('.js-kp-modal-title').textContent = modalTitle;
            modal.querySelector('.js-kp-modal-text').textContent = modalText;
            // modal.querySelector('.js-kp-modal-button').textContent = modalButton;

            modal.classList.remove('tw-hidden');

            // Hide/Show arrows based on position
            const prevBtn = modal.querySelector('.js-kp-modal-prev');
            const nextBtn = modal.querySelector('.js-kp-modal-next');

            if (prevBtn) prevBtn.style.display = sequenceIndex === 0 ? 'none' : 'flex';
            if (nextBtn) nextBtn.style.display = sequenceIndex === sequence.length - 1 ? 'none' : 'flex';
        };

        tips.forEach(function (tip, index) {
            tip.addEventListener('click', () => {
                const sequence = currentTrackType === 'competition' ? competitionSequence : rentingSequence;
                const seqIndex = sequence.indexOf(index);
                updateModalContent(seqIndex);
            });
        });

        const modal = document.querySelector('.js-kp-tip-modal');
        const prevBtn = modal.querySelector('.js-kp-modal-prev');
        const nextBtn = modal.querySelector('.js-kp-modal-next');

        if (prevBtn) {
            prevBtn.addEventListener('click', () => {
                if (currentIndexInSequence > 0) {
                    updateModalContent(currentIndexInSequence - 1);
                }
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                const sequence = currentTrackType === 'competition' ? competitionSequence : rentingSequence;
                if (currentIndexInSequence < sequence.length - 1) {
                    updateModalContent(currentIndexInSequence + 1);
                }
            });
        }

        const modalCloseBtns = block.querySelectorAll('.js-kp-modal-close');
        modalCloseBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                const modal = btn.closest('.js-kp-tip-modal');
                modal.classList.add('tw-hidden');
            });
        });


    });
});



/* eslint-enable no-console */
